import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Locations_ds_get_warehouses_timezone_detailsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { warehouseIds: number[], $top?: number, $skip?: number }): Promise<{ result?: { Id?: number, TimeZoneId?: string, TimeZone?: string, Offset?: number }[], totalCount?: number }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseIds)) {
      missingRequiredInParams.push('\'warehouseIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Locations/datasources/ds_get_warehouses_timezone_details/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouseIds?: number[], $keys: number[] }): Promise<{ result?: { Id?: number, TimeZoneId?: string, TimeZone?: string, Offset?: number }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Locations/datasources/ds_get_warehouses_timezone_details/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      warehouseIds: number[]    }) {
        if(isNil(inParams.warehouseIds)) {
          return true; 
        }
      return false;
    }
}
